import {useSelector} from "react-redux";
import {StoreType} from "../../store/spirs/types";
import {FixtureElement} from "../../models/api/codegen/code";

export function useRate(status: FixtureElement['s']) {
    const type = useSelector((state: StoreType) => state.spirs.coupons.currentCouponType);
    const enableStepLive = useSelector((state: StoreType) => state.enableDefaultLiveStep);
    const enableStepLine = useSelector((state: StoreType) => state.enableDefaultLineStep);
    const settings = useSelector((state: StoreType) => state.spirs.playerSettings);

    if (type === 'EXPRESS' || type === 'SYSTEM') {
        return 0;
    } else {
        if (status === "NOT_STARTED" && enableStepLine) {
            return settings.defaultLine;
        }
        if (status === "LIVE" && enableStepLive) {
            return settings.defaultLive;
        }
        return 0;
    }

}
